const pages = "/auth/"

export const UPDATE_AUTH_DATA = `${pages}UPDATE_AUTH_DATA`;
export const UPDATE_EXAM = `${pages}UPDATE_EXAM`;

